<template>
  <div>
    <el-main class="my-main" style="background-color: white;border-radius: 10px">
      <el-input size="small" class="my-el-input" style="margin-left: 10px" v-model="search.searchTitle"
                placeholder="标题"
                clearable></el-input>
      <el-select size="small" class="my-el-input" v-model="search.searchCategory"
                 style="margin-top: 20px;margin-left: 10px"
                 placeholder="分类">
        <el-option label="无" value="0"></el-option>
        <el-option
          v-for="item in categories"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-button size="small" style="margin-top: 20px;margin-left: 10px" @click="searchBtn" type="primary">搜索
      </el-button>
      <el-button size="small" style="margin-top: 20px;margin-left: 10px" @click="searchClear" plain>清除</el-button>

      <el-table
        :data="blog"
        border
        tooltip-effect="dark"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        style="width: max-content;margin-top: 20px;margin-left: 10px;">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-row :gutter="15">
              <el-col :span="15">
                <el-input style="margin-left: 20px" size="small" v-model="props.row.title"
                          placeholder="请输入文章标题"></el-input>
              </el-col>
              <el-col :span="5">
                <el-button style="border-radius: 20px;margin-left: 20px" type="danger" size="small"
                           @click="openEdit(props.row)">
                  修改文章
                </el-button>
                <el-button style="border-radius: 20px" size="small" type="success" @click="openImageUpload">上传图片
                </el-button>
              </el-col>
            </el-row>
            <el-row>
              <mavon-editor
                ref="md"
                v-model="props.row.contentText"
                @save="saveMd"
                style="margin: 10px 20px 10px 20px;min-height: 70vh"/>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
          width="350"
          label="标题"
          prop="title">
        </el-table-column>
        <el-table-column
          width="80"
          label="阅读量"
          prop="viewCount">
        </el-table-column>
        <el-table-column
          width="80"
          label="评分"
          prop="score">
        </el-table-column>
        <el-table-column
          width="80"
          label="分类"
          prop="categoryName">
        </el-table-column>
        <el-table-column
          width="200"
          label="创建时间"
          prop="createTime">
        </el-table-column>
        <el-table-column
          width="200"
          label="更新时间"
          prop="updateTime">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 30px"
        background
        layout="total,prev, pager, next,jumper"
        :current-page.sync="currentPage"
        :page-size="5"
        @current-change="currentChange"
        :total="totalCount">
      </el-pagination>

      <el-dialog :lock-scroll="false" :close-on-click-modal="false" :close-on-press-escape="false" title="修改文章"
                 width="500px" :visible.sync="dialogFormVisible">
        <el-form :model="currentBlogData" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item label="文章分类：" :label-width="formLabelWidth" prop="categoryId">
            <el-select style="width: 140px" size="small" v-model="currentBlogData.categoryId" placeholder="请选择">
              <el-option
                v-for="item in categories"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文章介绍：" :label-width="formLabelWidth" prop="introduction">
            <el-input type="textarea" :autosize="{minRows:5}" v-model="currentBlogData.introduction"
                      placeholder="请输入介绍" size="small"
                      style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="文章首图：" :label-width="formLabelWidth" prop="firstImage">
            <el-upload
              class="avatar-uploader"
              :action="uploadActionUrl+'/uploadImage'"
              name="image"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="currentBlogData.firstImage" :src="currentBlogData.firstImage" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
          <el-popover
            placement="top"
            width="160"
            title="最后一次提示"
            v-model="form.visible">
            <p>是否保存了文章(ctrl+s)？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="small" @click="goSave">去保存</el-button>
              <el-button size="small" type="success" @click="submit('ruleForm')">确认</el-button>
            </div>
            <el-button size="small" type="primary" slot="reference">修改文章</el-button>
          </el-popover>
        </div>
      </el-dialog>

      <el-dialog :lock-scroll="false" :close-on-click-modal="false" :close-on-press-escape="false" title="上传图片"
                 width="500px" :visible.sync="uploadStaticImageVisible">
        <el-upload
          class="upload-demo"
          :action="uploadStaticImage"
          :on-preview="beforeAvatarUpload"
          :on-success="uploadStaticImageSuccess"
          name="image"
          list-type="picture">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2000kb</div>
        </el-upload>
        <span>图片地址:{{ uploadStaticImagePath }}</span>
      </el-dialog>

    </el-main>
  </div>
</template>

<script>
import request from "../../utils/axiosUtils";
import base_url from "../../utils/Constants";

export default {
  name: "BlogManager",
  data() {
    var validateCategory = (rule, value, callback) => {
      if (!this.currentBlogData.categoryId) {
        return callback(new Error('分类不能为空'));
      } else {
        callback()
      }
    };
    var validateIntroduction = (rule, value, callback) => {
      if (!this.currentBlogData.introduction) {
        return callback(new Error('介绍不能为空'));
      } else {
        callback()
      }
    };
    var validateFirstImage = (rule, value, callback) => {
      if (!this.currentBlogData.firstImage) {
        return callback(new Error('图片不能为空'));
      } else {
        callback()
      }
    };
    return {
      //静态图片上传
      uploadStaticImage: base_url + '/uploadStaticImage',
      base_url: base_url,
      uploadStaticImageVisible: false,
      uploadStaticImagePath: null,
      base_url_uploadImage: base_url + '/uploadImage',

      //编辑框是否打开
      dialogFormVisible: false,
      categories: [
        {
          id: null,
          name: null,
        }
      ],
      formLabelWidth: '100px',
      form: {
        visible: false
      },
      rules: {
        categoryId: [
          {required: true, validator: validateCategory, trigger: 'blur'}
        ],
        introduction: [
          {required: true, validator: validateIntroduction, trigger: 'blur'}
        ],
        firstImage: [
          {required: true, validator: validateFirstImage, trigger: 'blur'}
        ]
      },
      blog: [],
      search: {
        searchTitle: null,
        searchCategory: null,
        adminId: null,
        currentPage: null,
      },
      //当前的博客数据，将会被修改的内容
      currentBlogData: {
        id: '',
        categoryId: '',
        firstImage: '',
        introduction: '',
        title: '',
        contentHtml: '',
        contentText: '',
        adminId: ''
      },
      //当前查询状态  0:正常查询  1:条件查询
      selectState: 0,
      //当前页码
      currentPage: 1,
      //记录总数
      totalCount: null,

      //管理员登录信息
      adminInfo: {},

      //图片上传路径
      uploadActionUrl: base_url
    }
  },
  methods: {
    //上传图片
    openImageUpload() {
      this.uploadStaticImageVisible = true
    },
    handleTime(date) {
      let time = new Date(
        date.substr(0, 4),
        parseInt(date.substr(5, 2)) - 1,
        date.substr(8, 2),
        date.substr(11, 2),
        date.substr(14, 2),
        date.substr(17, 2),
      );
      let year = time.getFullYear();
      let month = this.handleZero(time.getMonth() + 1);
      let day = this.handleZero(time.getDate());
      let hours = this.handleZero(time.getHours());
      let minutes = this.handleZero(time.getMinutes());
      let seconds = this.handleZero(time.getSeconds());
      return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
    },
    handleZero(time) {
      if (time < 10) {
        return '0' + time;
      } else {
        return time
      }
    },
    //处理博客获取的数据
    handlerBolgResult(response) {
      let data = response.data.data;
      data.forEach(value => {
        let oneStar = value.oneStar;
        let twoStar = value.twoStar;
        let threeStar = value.threeStar;
        let fourStar = value.fourStar;
        let fiveStar = value.fiveStar;
        let totalStar = oneStar + twoStar + threeStar + fourStar + fiveStar;
        // console.log(oneStar, twoStar, threeStar, fourStar, fiveStar)
        value.createTime = this.handleTime(value.createTime);
        value.updateTime = this.handleTime(value.updateTime);
        if (oneStar === 0 && twoStar === 0 && threeStar === 0 && fourStar === 0 && fiveStar === 0) {
          value.score = 0;
          return;
        }
        value.score = ((fiveStar / totalStar * 100 / 100 * 5 +
          fourStar / totalStar * 100 / 100 * 4 +
          threeStar / totalStar * 100 / 100 * 3 +
          twoStar / totalStar * 100 / 100 * 2 +
          oneStar / totalStar * 100 / 100 * 1) * 2).toFixed(1);
      })
      this.blog = data
    },
    //获取博客
    getBlog() {
      request({
        url: '/blog/getBlogForManager',
        method: 'get',
        params: {
          page: this.currentPage,
          adminId: this.currentBlogData.adminId
        }
      }).then(response => {
        this.handlerBolgResult(response)
      })
    },
    //条件查询博客
    getBlogByCondition() {
      let searchTitle = this.search.searchTitle;
      let searchCategory = this.search.searchCategory;
      // console.log(searchTitle, searchCategory)
      if (searchTitle !== null || searchCategory !== null) {
        this.search.currentPage = this.currentPage;
        this.search.adminId = this.currentBlogData.adminId;
        // console.log(this.search)
        request({
          url: '/blog/getBlogByCondition',
          method: 'get',
          params: {
            condition: this.search,
          }
        }).then(response => {
          this.handlerBolgResult(response)
        })
      } else {
        this.$notify.error({
          title: '错误',
          message: '请加入条件'
        });
      }
    },
    //打开博客编辑页面
    openEdit(row) {
      // console.log(row)
      for (let b of this.blog) {
        if (b.id === row.id) {
          if (b.firstImage.indexOf("http://") === -1)
            b.firstImage = base_url + "/getImage/" + b.firstImage;
          this.currentBlogData.id = b.id;
          this.currentBlogData.categoryId = b.categoryId;
          this.currentBlogData.firstImage = b.firstImage;
          this.currentBlogData.introduction = b.introduction;
          this.currentBlogData.title = b.title;
          break;
        }
      }
      this.dialogFormVisible = true;
    },
    //获取分类
    getCategory() {
      request({
        url: '/blog/getCategories',
        method: 'get',
      }).then(response => {
        // console.log(response)
        this.categories = response.data.data;
      })
    },
    //处理头像成功
    handleAvatarSuccess(result) {
      // console.log(result)
      let data = result.data;
      this.currentBlogData.firstImage = data;
    },
    //上传静态图片成功
    uploadStaticImageSuccess(result) {
      this.uploadStaticImagePath = "<img src='" + result.data + "' width='100' height='100'>";
    },
    //上传头像前
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else if (isPng) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
        return false;
      }
    },
    //去保存
    goSave() {
      this.form.visible = false;
      this.dialogFormVisible = false;
    },
    //提交文章内容
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.visible = false;
          if (this.blog.title !== '') {
            if (this.currentBlogData.contentHtml !== '' && this.currentBlogData.contentText !== '') {
              request({
                url: '/blog/updateBlog',
                method: 'post',
                data: {
                  blogInfoJson: JSON.stringify(this.currentBlogData),
                },
                params: {
                  adminInfo: this.adminInfo
                }
              }).then(response => {
                if (response.data.flag) {
                  this.dialogFormVisible = false;
                  this.handlerSelect()
                }
              }).catch(e=>{
                this.$notify.error({
                  title: '博客',
                  message: '网络错误'
                })
              })
            } else {
              this.dialogFormVisible = false;
              this.$notify.error({
                title: '博客',
                message: '没有保存'
              })
            }
          } else {
            this.dialogFormVisible = false;
            this.$notify.error({
              title: '标题',
              message: '没有文章标题'
            })
          }
        } else {
          return false;
        }
      });
      this.form.visible = false;
    },
    //处理删除单个文章
    handleDelete(index, data) {
      this.$confirm('此操作将逻辑删除该文章, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/blog/delete',
          method: 'post',
          params: {
            id: data.id,
            adminInfo: this.adminInfo
          }
        }).then(response => {
          if (response.data.flag) {
            if (this.blog.length === 1) {
              this.currentPage = this.currentPage - 1;
              if (this.currentPage <= 0) {
                this.currentPage = 1;
              }
            }
            this.handlerSelect();
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    //保存文章
    saveMd(value, render) {
      this.currentBlogData.contentHtml = render;
      this.currentBlogData.contentText = this.$refs.md.d_value
      // console.log(this.$refs.md.d_value);
    },
    //查询博客的数量
    getBlogCount() {
      request({
        url: '/blog/getBlogForManagerCount',
        method: 'get',
        params: {
          adminId: this.currentBlogData.adminId,
        }
      }).then(response => {
        this.totalCount = response.data.data;
      })
    },
    //获取条件查询博客的数量
    getBlogByConditionCount() {
      // console.log(this.search)
      request({
        url: '/blog/getBlogByConditionCount',
        method: 'get',
        params: {
          condition: this.search
        }
      }).then(response => {
        this.totalCount = response.data.data;
      })
    },
    //分页的点击时间
    currentChange(val) {
      this.currentPage = val;
      this.handlerSelect();
    },
    //点击搜索按钮时
    searchBtn() {
      this.selectState = 1
      this.currentPage = 1;
      this.handlerSelect();
    },
    //点击清楚搜索按钮时
    searchClear() {
      this.selectState = 0;
      this.currentPage = 1;
      this.search.searchCategory = '无'
      this.search.searchTitle = ''
      this.handlerSelect();
    },
    //处理查询分支
    handlerSelect() {
      if (this.selectState === 0) {
        this.getBlog();
        this.getBlogCount();
      } else {
        this.getBlogByCondition();
        this.getBlogByConditionCount()
      }
    }
  },
  mounted() {
    let adminInfo = JSON.parse(window.sessionStorage.getItem("adminInfo"));
    this.currentBlogData.adminId = adminInfo.id;
    this.adminInfo = adminInfo;
    this.handlerSelect()
    this.getCategory();
  }
}
</script>

<style>
.my-main .el-button + .el-button {
  margin-left: 0;
}

.my-main .my-el-input {
  width: 200px;
}

.my-main .demo-table-expand {
  font-size: 0;
}

.my-main .demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.my-main .demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/BlogManager.vue